import { useEffect, type ReactElement, type ReactNode } from 'react';

import styles from './PageHead.module.css';

interface Props {
  readonly title: string;
  readonly sub?: string;
  /** Trailing badges or chips that belong to the heading itself. */
  readonly adornment?: ReactNode;
  readonly actions?: ReactNode;
}

export function PageHead({ title, sub, adornment, actions }: Props): ReactElement {
  // The tab title follows the screen: an operator with six tabs open needs to
  // tell them apart without switching to each one.
  useEffect(() => {
    document.title = `${title} · CloudOrder`;
  }, [title]);

  return (
    <div className={styles.pagehead}>
      <div>
        <h1 className={styles.title}>
          {title}
          {adornment}
        </h1>
        {sub ? <div className={styles.sub}>{sub}</div> : null}
      </div>
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </div>
  );
}
